import {chain2} from "@Common/utils/fs";

export const getColorC = (objs, {vpSize}) => {
    const getColors = objs.map((o) => o.getColorC({vpSize})).filter(v=>v);

    return !getColors.length ? null : (p) => chain2(null, getColors.map((getColor) => getColor(p)));
};
